import { ref, createApp, onMounted } from 'vue'

const app = createApp({
  setup() {
    const menuState = ref(false)
    const menuOpen = () => {
      menuState.value = true
    }
    const menuClose = () => {
      menuState.value = false
    }
    onMounted(() => {
      const mainVisual = document.getElementById('mainVisual')
      const header = document.getElementById('headerPC')
      const main = document.getElementById('main')
      if (mainVisual) {
        window.addEventListener('scroll', () => {
          const scrollHeight = document.documentElement.scrollTop
          if (scrollHeight > mainVisual!.clientHeight) {
            header?.classList.add('fixed')
            main!.style.marginTop = header!.clientHeight + 'px'
          } else {
            header?.classList.remove('fixed')
            main!.style.marginTop = 'auto'
          }
        })
      }
    })
    return { menuOpen, menuClose, menuState }
  }
})
if (document.getElementById('headerPC') != null) {
  app.mount('#headerPC')
}
